import React from "react";

import "../styles.css";

const LoanInfo = ({ data }) => {
  return (
    <div className="detail-bold-text loan-info-container">
      <div className="row loan-info-row">
        <div className="col-4">NIK</div>
        <div className="col-md-auto">:</div>
        <div className="col">{data?.customerNIK}</div>
      </div>
      <div className="row loan-info-row">
        <div className="col-4">Jenis Kelamin</div>
        <div className="col-md-auto">:</div>
        <div className="col">{data?.customerGender}</div>
      </div>
      <div className="row loan-info-row">
        <div className="col-4">Tanggal Lahir</div>
        <div className="col-md-auto">:</div>
        <div className="col">{data?.customerDOB}</div>
      </div>
      <div className="row loan-info-row">
        <div className="col-4">Alamat</div>
        <div className="col-md-auto">:</div>
        <div className="col">{data?.customerAddress}</div>
      </div>
      <div className="row loan-info-row">
        <div className="col-4">Foto KTP</div>
        <div className="col-md-auto">:</div>
        <div className="col">{data?.customerKTPPicture}</div>
      </div>
      <div className="row loan-info-row">
        <div className="col-4">Bank / No. Rekening</div>
        <div className="col-md-auto">:</div>
        <div className="col">{data?.bankOrAccountNumber}</div>
      </div>
      <div className="row loan-info-row">
        <div className="col-4">Nama Rekening</div>
        <div className="col-md-auto">:</div>
        <div className="col">{data?.accountName}</div>
      </div>
      <div className="row loan-info-row">
        <div className="col-4">Barang Jaminan</div>
        <div className="col-md-auto">:</div>
        <div className="col">{data?.product}</div>
      </div>
    </div>
  );
};

export default LoanInfo;
